import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import MigrateSvg from '../../../assets/icons/nav/migrate.svg?raw';

export const MigrateIcon = (props) => <CustomSVG svg={MigrateSvg} preserveColors {...props} />;
